import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedCancerRiderCodes {
    
    public readonly key = 'UnassignedCancerRiderCodes';
  }

export type CancerRiderCodeAmount = Async<Array<{code:string,units:string[]}>> | UnassignedCancerRiderCodes;

type MatchCancerRiderCodeAmountOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (riderCodes: Array<{code:string,units:string[]}>) => TReturn;
    Error: () => TReturn;
    Unassigned: (riderCodes: []) => TReturn;
  };

export const isLoading = (riderCodes: CancerRiderCodeAmount): riderCodes is Loading<Array<{code:string,units:string[]}>> =>
    riderCodes.key === 'Loading';

export const isLoaded = (riderCodes: CancerRiderCodeAmount): riderCodes is Loaded<Array<{code:string,units:string[]}>> => riderCodes.key === 'Loaded';

export const matchCriticalIllnessProduct = <TReturn>(options: MatchCancerRiderCodeAmountOptions<TReturn>) => (
    products: CancerRiderCodeAmount
  ) => {
  
    switch (products.key) {
      case 'UnassignedCancerRiderCodes':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  